import PubSub from "underpub-js";

var CardTeamMember = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardTeamMember',
	};

	$.extend(true, this.options, options);

};

CardTeamMember.prototype.init = function() {

	var self = this;

};

export default CardTeamMember;
